export default __webpack_public_path__ + "static/media/gear.163ebd03.svg";